import { jsx as t, jsxs as B, Fragment as R } from "react/jsx-runtime";
import { useCallback as g } from "react";
import { useTheme as j } from "styled-components";
import { ILLUSTRATIONS as I } from "../../../../assets/illustrations/illustrations.js";
import O from "../../hooks/use-click-handler.js";
import { Button as S, Loader as T, Icon as b, Label as v } from "./button-styled.js";
const w = ({
  label: r,
  renderAs: o,
  size: n = "regular",
  shape: s = "curved",
  disabled: a = !1,
  busy: e = !1,
  width: c,
  widthX: d,
  Icon: i,
  iconPosition: u = "left",
  onClick: m,
  alignSelf: $,
  justifyContent: f = "center",
  analyticsLabel: h,
  analyticsProps: p,
  children: C,
  ...L
}) => {
  const { button: k } = j(), { textVariant: x } = k.sizes[n], { handleClick: l } = O({ label: r, analyticsLabel: h, analyticsProps: p }, m), A = g(() => {
    if (e) return null;
    l();
  }, [e, l]);
  return /* @__PURE__ */ t(
    S,
    {
      disabled: a,
      $alignSelf: $,
      $justifyContent: f,
      $width: c,
      $widthX: d,
      $renderAs: o,
      $size: n,
      $shape: s,
      onClick: A,
      "data-busy": e,
      ...L,
      children: e ? /* @__PURE__ */ t(T, { src: I.LOADER, alt: "Loader", $size: n }) : /* @__PURE__ */ B(R, { children: [
        i ? /* @__PURE__ */ t(b, { $buttonRenderAs: o, $iconPosition: u, $size: n, children: /* @__PURE__ */ t(i, {}) }) : void 0,
        /* @__PURE__ */ t(v, { $renderAs: x, $buttonRenderAs: o, children: r }),
        C
      ] })
    }
  );
}, P = w;
export {
  P as default
};
//# sourceMappingURL=button.js.map
